'use client';

import { type ReactElement } from 'react';
import { cn } from '@/lib/utils';
import { CurrencyDisplay } from './currency-display';
import { StoresMenu } from './stores-menu';
import { AccountMenu } from './account-menu';
import { NdulgeLink } from './ndulge-link';
import { WishlistIcon } from './wishlist-icon';
import { CartBadge } from './cart-badge';

interface UserActionsProps {
    /** Condensed header: desktop keeps only the bag. Hidden with CSS, not unmounted. */
    condensed?: boolean;
}

/**
 * The header "user menu" — the row of links right of the search form: currency, stores, account, NDULGE,
 * wishlist, cart. On mobile only the account icon and cart stay; the row hides the rest with
 * `hidden lg:flex`. Hiding lives here, not in the components, so the burger menu can reuse them visible.
 */
export const UserActions = ({ condensed = false }: UserActionsProps): ReactElement => {
    const desktopOnly = cn('hidden', condensed ? 'lg:hidden' : 'lg:flex');

    return (
        <div className="flex items-center gap-4 lg:gap-6" data-slot="user-actions">
            <CurrencyDisplay className={desktopOnly} />
            <StoresMenu className={desktopOnly} />
            <AccountMenu className={cn(condensed && 'lg:hidden')} />
            <NdulgeLink className={desktopOnly} />
            <WishlistIcon className={desktopOnly} />
            <CartBadge />
        </div>
    );
};
